import React, { useState, useRef } from "react";
import EmojiPicker, { Emoji } from "emoji-picker-react";
import {
  KoModal,
  KoButton,
  KoLoader,
  KoToast,
  KoTitle,
  KoDP,
  KoDateFormatter,
  KoText,
  KoPopOver
} from "packages";
import KoIcon from "@kwapio/icons";
import styles from "./feedcomments.module.scss";
import KoRichTextEditorReadOnly from "packages/richText/richTextView";
// import { getCookie } from "shared/utils/cookies";

const KoComments = ({
  workspaceId,
  ticketId,
  fetchComments,
  createCommentAPI,
  comments,
  actions,
  deleteCommentAPI,
  reactionAPI,
  uploadAPI,
  source = "comments"
}) => {
  const [loading, setLoading] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);

  const commentRefs = useRef({});


//   const handleSubmit = async(values) => {
//     setLoading(true);

//     const payload = {
//       ...values,
//       ticketId,
//       parentCommentId: action === "Reply" ? currentRecord?.commentId : undefined
//     };

//     await createCommentAPI(payload, currentRecord?.commentId, workspaceId);

//     KoToast.success(`Comment ${action || "created"} successfully`);

//     form.resetFields();
//     setCurrentRecord(null);
//     setAction(null);

//     await loadComments();
//     setLoading(false);
//   };

  const handleDelete = async() => {
    setLoading(true);
    await deleteCommentAPI(ticketId, currentRecord?.commentId, workspaceId);
    KoToast.success("Comment deleted");
    setDeleteOpen(false);
    setCurrentRecord(null);
    setLoading(false);
  };

  const handleReaction = async(emoji, record) => {
    await reactionAPI(ticketId, record.commentId, workspaceId, { reaction: emoji });
  };

  const emojiContent = (record) => (
    <EmojiPicker
      height={400}
      width={320}
      emojiStyle="native"
      onEmojiClick={(e) => handleReaction(e.unified, record)}
      previewConfig={{ showPreview: false }}
    />
  );

  return (
    comments.length > 0 && <div className={styles.wrapper}>
      {loading && <KoLoader />}

      {comments.map((comment) => (
        <div
          key={comment.commentId}
          className={styles.commentContainer}
          ref={(el) => (commentRefs.current[comment.commentId] = el)}
        >
          <div className={styles.commentPic}>
            <KoDP width={36} height={36} logo={comment?.profile?.logo} />
          </div>

          <div className={styles.commentWrapper}>
            <div className={styles.commentHeader}>
              <div className={styles.commentName}>
                <KoTitle level={5} text={comment?.profile?.firstName} />
                <KoTitle level={5} text={comment?.profile?.lastName} />
              </div>
              <div className={styles.dot} />
              <KoDateFormatter
                data={comment?.createdAt}
                format="DD-MMM-YYYY hh:mm A"
              />
            </div>

            <div className={styles.comment}>
              <KoRichTextEditorReadOnly
                initialValues={comment?.content}
              />

              {actions &&  <div className={styles.commentFooter}>
                <KoButton
                  type="text"
                  icon={<KoIcon name="ReplyOutlined" />}
                  onClick={() => {
                    setCurrentRecord(comment);
                    // setModalOpen(true);
                  }}
                />

                <KoPopOver
                  content={emojiContent(comment)}
                  trigger="click"
                >
                  <KoButton
                    type="text"
                    icon={<KoIcon name="SmileyOutlined" />}
                  />
                </KoPopOver>

                <KoButton
                  type="text"
                  icon={<KoIcon name="EditOutlined" />}
                  onClick={() => {
                    setCurrentRecord(comment);
                    // setModalOpen(true);
                  }}
                />

                <KoButton
                  type="text"
                  icon={<KoIcon name="DeleteOutlined" />}
                  onClick={() => {
                    setCurrentRecord(comment);
                    setDeleteOpen(true);
                  }}
                />
              </div>}

              {!!comment?.reactions?.length && (
                <div className={styles.reactions}>
                  {comment.reactions.map((r, i) => (
                    <div key={i} className={styles.reaction}>
                      <Emoji size={16} unified={r.reaction} />
                      <KoText text={r.count} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    
    

      <KoModal
        title="Delete Comment"
        open={isDeleteOpen}
        onClose={() => setDeleteOpen(false)}
        footer={[
          <KoButton
            key="cancel"
            label="Cancel"
            onClick={() => setDeleteOpen(false)}
          />,
          <KoButton
            key="delete"
            type="primary"
            loading={loading}
            label="Delete"
            onClick={handleDelete}
          />
        ]}
      >
        <KoTitle level={5} text="This action cannot be undone" />
      </KoModal>
    </div>
  );
};

export default KoComments;
